import { useEffect, useRef, useState } from "react";
import { FaClipboardList, FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import { setAuth } from "../../../store/reducer/auth";
import { updateUser } from "../../../store/reducer/user";
import api from "../../../Utils/api";
import { API_URL_FILE, BASE_URL, IMG_USER_URL } from "../../../Utils/constants";

const User = () => {
  const img_url_default = BASE_URL + "/dist/";
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [update, setUpdate] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const passwordRef = useRef(null);
  const repasswordRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(userData);
    try {
      const { data } = await api.put(`users/${userData.id}`, userData);
      if (!data.user) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }
      toast.success("Mise à jour éffectuée.");
      dispatch(updateUser(userData));

      if (userData.id === auth.id) {
        dispatch(setAuth(userData));
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
      setUpdate(false);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();

    const data = {
      password: password,
    };
    try {
      const response = await api.put(`users/${userData.id}`, data);
      if (response.data.user) {
        // console.log(data, auth.id, response.data.user);
        setPassword("");
        passwordRef.current.value = "";
        repasswordRef.current.value = "";
        toast.success("Mise à jour éffectuée.");
      } else {
        toast.error("Vérifier vos données avant la soumission.");
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleCheckPassword = (e) => {
    const { value } = e.target;
    if (password !== value) {
      setPassword("");
      passwordRef.current.value = "";
      e.target.value = "";
      toast.error("Les mots de passe ne sont pas identiques.");
    }
  };

  const handleCheckContact = (e) => {
    const { value, name } = e.target;
    if (value.length <= 0) return;
    // const regex = /^\+\d{1,2}\s?\d{10}$/;
    // console.log(value.length);
    if (value.length < 10) {
      e.target.value = "";
      setUserData((prev) => ({ ...prev, [name]: "" }));
      toast.warning("Le contact doit contenir au moins 10 chiffres.");
    }
  };

  document.title = "DashBoard | Utilisateur";

  useEffect(() => {
    if (id) {
      const loadUser = async (id) => {
        //dispatch(setLoading(true));

        try {
          const response = await api.get(`users/${id}`);
          const { user } = response.data;

          if (!user) {
            toast.error("Cet utilisateur n'existe pas !");
            navigate("utilisateurs");
          }
          const data = {
            id: user.id,
            lastname: user.lastname,
            firstname: user.firstname,
            username: user.username,
            contact: user.contact,
            roles: user.roles.includes("ROLE_ADMIN")
              ? "ROLE_ADMIN"
              : "ROLE_MOD",
            isActif: user.isActif,
            img: user.img,
          };

          setUserData(data);
        } catch (error) {
          if (error.response.status === 404) {
            toast.info(
              "L'utilisateur que vous venez de sélectionner n'existe pas!"
            );
            navigate("/utilisateurs");
          }
          if (error.response.status === 401) {
            navigate("/login");
          }
        }
      };
      loadUser(id);
    }
  }, [id]);

  return (
    <>
      <PageHeader page="Détails Utilisateur" />

      {/* Modal */}
      <>
        <div
          className="modal fade"
          id="changePassword"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Changer le mot de passe
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form
                className="form-horizontal"
                onSubmit={handleChangePasswordSubmit}
              >
                <div className="modal-body">
                  <div className="form-group row">
                    <label
                      htmlFor="password"
                      className="col-sm-5 col-form-label"
                    >
                      Nouveau mot de passe
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={(e) => setPassword(e.target.value)}
                        ref={passwordRef}
                        placeholder="Nouveau mot de passe"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="repassword"
                      className="col-sm-5 col-form-label"
                    >
                      Confirmer mot de passe
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="password"
                        className="form-control"
                        id="repassword"
                        name="repassword"
                        onBlur={handleCheckPassword}
                        ref={repasswordRef}
                        placeholder="Confirmer mot de passe"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Valider
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
      {/* Modal */}

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              {/* Profile Image */}
              <div className="card card-primary card-outline">
                <div className="card-body box-profile">
                  <div
                    className="text-center mb-3 hover-div"
                    style={{
                      height: "26rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {userData?.img && (
                      <img
                        className="profile-auth-img img-fluid img-circle"
                        style={{ height: "220px", width: "220px" }}
                        src={
                          userData?.img &&
                          (userData?.img.split("/").length > 1
                            ? img_url_default
                            : API_URL_FILE + "/" + IMG_USER_URL) + userData?.img
                        }
                        height={220}
                        width={220}
                        alt="CurrenUser profile"
                      />
                    )}
                  </div>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
              {/* /.card */}
            </div>
            <div className="col-md-9">
              <div className="card">
                <div className="card-header">
                  {update && (
                    <button
                      type="button"
                      className="btn btn-primary ml-2 mt-1"
                      data-toggle="modal"
                      data-target="#changePassword"
                    >
                      Changer mot de passe
                    </button>
                  )}
                  <div
                    className="card-tools"
                    style={{
                      marginBottom: "-2%",
                    }}
                  >
                    <div
                      className="mr-3"
                      style={{
                        color: "#ccc",
                        cursor: "pointer",
                        fontSize: "1.6rem",
                      }}
                      onClick={() => setUpdate(!update)}
                    >
                      <p
                        style={{
                          color: "#1d75f0",
                        }}
                      >
                        {update ? <FaClipboardList /> : <FaEdit />}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {userData && (
                    <form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="form-group row">
                        <label
                          htmlFor="lastname"
                          className="col-sm-2 col-form-label"
                        >
                          Nom
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control"
                            id="lastname"
                            name="lastname"
                            placeholder="Nom"
                            onChange={(e) => handleChange(e)}
                            value={userData.lastname}
                            disabled={!update}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          htmlFor="firstname"
                          className="col-sm-2 col-form-label"
                        >
                          Prénom
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control"
                            id="firstname"
                            name="firstname"
                            placeholder="Prénom"
                            onChange={handleChange}
                            value={userData.firstname}
                            disabled={!update}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          htmlFor="username"
                          className="col-sm-2 col-form-label"
                        >
                          Nom d'utilisateur
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control"
                            id="username"
                            name="username"
                            placeholder="Nom d'utilisateur"
                            onChange={handleChange}
                            value={userData.username}
                            disabled={!update}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          htmlFor="contact"
                          className="col-sm-2 col-form-label"
                        >
                          Contact
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control"
                            id="contact"
                            name="contact"
                            placeholder="Contact"
                            onBlur={handleCheckContact}
                            onChange={handleChange}
                            value={userData.contact}
                            disabled={!update}
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          htmlFor="role"
                          className="col-sm-2 col-form-label"
                        >
                          Role
                        </label>
                        <div className="col-sm-10">
                          <select
                            className="custom-select form-control-border"
                            id="roles"
                            name="roles"
                            disabled={!update}
                            onChange={handleChange}
                            value={
                              userData.roles.includes("ROLE_ADMIN")
                                ? "ROLE_ADMIN"
                                : "ROLE_MOD"
                            }
                            required
                          >
                            <option>Choisir un role</option>
                            <option value="ROLE_MOD">Modérateur</option>
                            <option value="ROLE_ADMIN">Administrateur</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          htmlFor="status"
                          className="col-sm-2 col-form-label"
                        >
                          Status
                        </label>
                        <div className="col-sm-10">
                          <select
                            className="custom-select form-control-border"
                            id="isActif"
                            name="isActif"
                            onChange={handleChange}
                            disabled={!update}
                            value={userData.isActif}
                            required
                          >
                            <option>Choisir un status</option>
                            <option value="true">Activé</option>
                            <option value="false">Désactivé</option>
                          </select>
                        </div>
                      </div>
                      {update ? (
                        <div className="form-group row">
                          <div className="offset-sm-2 col-sm-10">
                            <button
                              type="submit"
                              className="btn btn-info"
                              disabled={loading}
                            >
                              {loading ? <Spin size="sm" /> : "Metre à jour"}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="form-group row">
                          <div className="offset-sm-2 col-sm-10">
                            <button
                              type="submit"
                              className="btn btn-info"
                              onClick={() => navigate("/utilisateurs")}
                            >
                              Retour
                            </button>
                          </div>
                        </div>
                      )}
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default User;
